module.exports = __webpack_public_path__ + "img/swap_horiz.80cea30e.svg";